/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_change_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can percentage change be negative?`)
};

const es_pct_change_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puede el cambio porcentual ser negativo?`)
};

const de_pct_change_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann die prozentuale Veränderung negativ sein?`)
};

const nl_pct_change_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan percentageverandering negatief zijn?`)
};

const fr_pct_change_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La variation en pourcentage peut-elle être négative ?`)
};

const it_pct_change_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La variazione percentuale può essere negativa?`)
};

const pt_br2_pct_change_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A variação percentual pode ser negativa?`)
};

const pt_pct_change_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A variação percentual pode ser negativa?`)
};

const ja_pct_change_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセント変化はマイナスになりますか？`)
};

const zh_pct_change_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`百分比变化可以是负数吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_change_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_change_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_change_faq2_q", locale)
	if (locale === "en") return en_pct_change_faq2_q(inputs)
	if (locale === "es") return es_pct_change_faq2_q(inputs)
	if (locale === "de") return de_pct_change_faq2_q(inputs)
	if (locale === "nl") return nl_pct_change_faq2_q(inputs)
	if (locale === "fr") return fr_pct_change_faq2_q(inputs)
	if (locale === "it") return it_pct_change_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_pct_change_faq2_q(inputs)
	if (locale === "pt") return pt_pct_change_faq2_q(inputs)
	if (locale === "ja") return ja_pct_change_faq2_q(inputs)
	return zh_pct_change_faq2_q(inputs)
};